import update from 'immutability-helper'
import clsx from 'clsx'
import React, {useState} from 'react'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import useStyles from './styles'

function shuffleArray(array = []) {
  return array.reduce((array, element, index, src) => {
    const i = src.length - 1 - index
    const j = Math.floor(Math.random() * (i + 1))
    if (i == j) {
      return array
    } else {
      const a = array[i]
      const b = array[j]
      return update(array, {$splice: [[i,1],[i,0,b],[j,1],[j,0,a]]})
    }
  }, array);
}


export default function MatchingQuestion ({context, question}) {

  const {answer, premise} = question
  const [state, setState] = React.useState({terms: [], definitions: [], selected: []})
  const classes = useStyles()
  const premiseText = premise.html || ''

  function handleChange(term, definition) {
          setState(update(state, {selected: {
            [state.selected.indexOf(definition)]: {$set: -1},
            [term]: {$set: definition},
          }}))
  }

  React.useEffect(() => {
    if (answer.choices) {
      const definitions = shuffleArray(answer.choices.map(([_,definition], index) => ({definition, index})))  
      const terms = shuffleArray(answer.choices.map(([term], index) => ({term, index})))
      const selected = terms.map(({term}, index) => -1)
      if(terms.length > 0){
        terms.map((term, index) => {
          selected[index] = definitions.findIndex( (def) => def.index === term.index);
        })
      }
      setState({terms, definitions, selected})

    }
  }, [])


  return (
    <Grid className={clsx(classes.root, "question", "matching")} container >
      <Grid className={clsx(classes.premise, "premise")} item xs={12}>
        {premiseText != '' && (<div className="instructions" dangerouslySetInnerHTML={{__html: premiseText}} />)}
      </Grid>
      <Grid item xs={12} container>
         {
         state.terms.map((term, index) => {
          const answerIndex = String.fromCharCode(Math.min(index, 20) + 65)
              return (
                <React.Fragment key={index} >
                 <Grid className="term" item xs={6}>
                      <SelectDefinition
                        index={index}
                        definitions={state.definitions}
                        onChange={handleChange}
                        value={ state.selected[index]}                        
                      />
                      <div className="value" dangerouslySetInnerHTML={{__html: term.term || ''}} />
                 </Grid>
                 <Grid item xs={6} className="definitions">
                      <Grid className={clsx("definition", {selected: state.selected.indexOf(state.definitions[index].index) > -1})}>
                        <Box className="index">{answerIndex}</Box>
                        <div className="value" dangerouslySetInnerHTML={{__html:  state.definitions[index].definition || ''}} />
                      </Grid>
                  </Grid>
                </React.Fragment>
              )
        })}
      </Grid>
    </Grid>
  )
}

function SelectDefinition (props) {

  function handleChange (e) {
    props.onChange(props.index, e.target.value)
  }

  return (
    <Select
      variant="standard" 
      className="select-definition"
      value={props.value}
      onChange={handleChange}
    >
      <MenuItem style={{display: 'none'}} value={-1}> </MenuItem>
      {props.definitions.map((definition, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 65)
        return (
          <MenuItem key={index} value={index}>{answerIndex}</MenuItem>
        )
      })}
    </Select>
  )
}
